module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ded2"
  }, [_vm._v("For the Tulsa gang—")]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_vm._v("Joy and Mike Bruza,")]), _vm._v(" "), _c('p', {
    staticClass: "ded1-1"
  }, [_vm._v("Caroline and Emily")]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_vm._v("Janythe and Tim Graham")]), _vm._v(" "), _c('p', {
    staticClass: "ded1-1"
  }, [_vm._v("Lauren and Scott")]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_vm._v("Jennifer Carwile")]), _vm._v(" "), _c('p', {
    staticClass: "ded1-1"
  }, [_vm._v("Meredith and Matt")]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_vm._v("And in memory of Jack and Tony Bruza")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65933e9c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SinsofSummer_dedi-1.vue
// module id = 72
// module chunks = 0